import {
  Tag, Coins, Building2, Landmark, BarChart3, TrendingUp, TrendingDown, Minus, Gem,
} from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const ITEMS_PER_PAGE = 20;

export const CHANNELS = [
  { id: "my_deals", labelKey: "opps.myDeals", name: "My Deals", icon: Tag, description: "Your created opportunities" },
  { id: "defi", labelKey: "opps.defi", name: "DeFi", icon: Coins, description: "Decentralized Finance yields" },
  { id: "stocks", labelKey: "opps.stocks", name: "Stocks", icon: BarChart3, description: "AI-powered stock & ETF trends" },
  { id: "commodities", labelKey: "opps.commodities", name: "Commodities", icon: Gem, description: "Precious metals, energy & agriculture" },
  { id: "web3_secondaries", labelKey: "opps.web3", name: "Web3 Secondaries", icon: Building2, description: "OTC & Secondaries from Acquire.Fi" },
  { id: "others", labelKey: "opps.others", name: "Others", icon: Landmark, description: "Custom investment opportunities" },
];

export const getRiskBadge = (score) => {
  if (score <= 30) return <Badge className="bg-green-500/10 text-green-500 border-green-500/20 text-[10px] cursor-default hover:bg-green-500/10">LOW</Badge>;
  if (score <= 70) return <Badge className="bg-yellow-500/10 text-yellow-500 border-yellow-500/20 text-[10px] cursor-default hover:bg-yellow-500/10">MEDIUM</Badge>;
  return <Badge className="bg-red-500/10 text-red-500 border-red-500/20 text-[10px] cursor-default hover:bg-red-500/10">HIGH</Badge>;
};

export const getApyColor = (apy) => {
  if (apy >= 20) return "text-green-500";
  if (apy >= 10) return "text-primary";
  return "text-muted-foreground";
};

export const getTimeAgo = (isoString) => {
  if (!isoString) return "Never";
  const diff = Date.now() - new Date(isoString).getTime();
  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
};

export const getOutlookColor = (outlook) => {
  if (!outlook) return "text-muted-foreground";
  const o = outlook.toLowerCase();
  if (o.includes("bullish")) return "text-green-500";
  if (o.includes("bearish")) return "text-red-500";
  return "text-yellow-500";
};

export const getOutlookIcon = (outlook) => {
  if (!outlook) return <Minus className="w-4 h-4" />;
  const o = outlook.toLowerCase();
  if (o.includes("bullish")) return <TrendingUp className="w-4 h-4" />;
  if (o.includes("bearish")) return <TrendingDown className="w-4 h-4" />;
  return <Minus className="w-4 h-4" />;
};

export const EMPTY_FORM = {
  name: "", category: "defi", protocol: "", chain: "", apy: "", tvl: "", token: "",
  opportunity_type: "manual", risk_score: 50, risk_notes: "", url: "", description: "",
  image_url: "", expected_return: "", notes: "", contact: "", price: "", ticket: "",
  custom_type: "", currency: "USD",
};
